import { render } from "./CategoryItemView.vue?vue&type=template&id=8973426a"
import script from "./CategoryItemView.vue?vue&type=script&lang=js"
export * from "./CategoryItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__